import styled from "styled-components";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.components.emptyState;

// STYLES
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

// DATA

// TYPES
export type Props = { message: string };

// CONSTANTS

// FUNCTIONS

// ASSETS
